import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const MasterOutletService = {
  getList: async (orgId) => {
    try {
      const url = `/master-outlets?organizationId=${orgId}`;
      const response = await apiService.get(url,{
        headers: {
               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await apiService.post(`/master-outlets`, data,{
        headers: {
               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating tenant:", error);
      throw error;
    }
  },
  
  detail: async (id) => {
    const response = await apiService.get(`/master-outlets/${id}`);
    return response.data;
  },
 
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/master-outlets/${id}`, updatedData,{
        headers: {
               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  delete: async (id) => {
    const response = await apiService.delete(`/master-outlets/${id}`,{
      headers: {
             authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },


};

export default MasterOutletService;
